import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const Errored = ({
  error,
  syncing,
  onSync,
}: {
  error: string
  syncing: boolean
  onSync: () => void
}) => {
  return (
    <Box
      background="radicalRed200"
      paddingX="s24"
      paddingY="s16"
      borderRadius={{
        all: 'abs008',
      }}
      gap="s16"
    >
      <Text.Header2>
        {i18n.t('payroll_integrations.incidences.datev_api.errored.title')}
      </Text.Header2>
      <Box>{error}</Box>
      <Button onClick={onSync} disabled={syncing}>
        {i18n.t('payroll_integrations.incidences.datev_api.errored.submit')}
      </Button>
    </Box>
  )
}

export default Errored
